/**
 * Tailwind CSS implementation of KeyboardKey component
 * Uses Seeds keyboard-key CSS classes from keyboard-key.css
 */

import * as React from "react";
import Text from "@sproutsocial/seeds-react-text";
import type { TypeKeyboardKeyProps } from "./KeyboardKeyTypes";

// Utility for merging class names properly
function cn(
  ...inputs: (string | undefined | null | false | Record<string, boolean>)[]
): string {
  const classes: string[] = [];

  for (const input of inputs) {
    if (!input) continue;

    if (typeof input === "string") {
      classes.push(input);
    } else if (typeof input === "object") {
      for (const [key, value] of Object.entries(input)) {
        if (value) {
          classes.push(key);
        }
      }
    }
  }

  return classes.join(" ");
}

export const KeyboardKeyTailwind = ({
  children,
  className,
  ...rest
}: TypeKeyboardKeyProps) => {
  return (
    <div
      className={cn("seeds-keyboard-key", className)}
      {...(rest as React.ComponentPropsWithoutRef<"div">)}
    >
      <kbd data-qa-keyboardkey={children}>
        <Text>{children}</Text>
      </kbd>
    </div>
  );
};

KeyboardKeyTailwind.displayName = "KeyboardKeyTailwind";
